import React, { useMemo } from 'react';

import { Badge } from '@mui/material';
import { IconWorld } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { DropDownMenu } from '@/components/lists/DropDownMenu';
import { DropDownMenuItem } from '@/components/lists/DropDownMenu/DropDownMenu.types';
import { useAuthStore } from '@/features/auth/stores/useAuthStore';
import { useMarketStore } from '@/features/markets/stores/useMarketStore';
import { castMarketToStoreMarket } from '@/features/markets/types/market';

import { SessionNavAvatar } from './SessionNavAvatar';
import { SessionNavChip } from './SessionNavChip';

export const NavSelectorMarket = () => {
    const { t } = useTranslation();
    const { market, setMarket } = useMarketStore();
    const { authUser } = useAuthStore();

    const title = useMemo(() => t('markets'), [t]);

    const items = useMemo(
        (): DropDownMenuItem[] =>
            authUser?.usersMarkets?.map((userMarket) => ({
                id: userMarket.market.id,
                label: userMarket.market.name,
                action: () => {
                    setMarket(castMarketToStoreMarket(userMarket.market));
                },
            })) ?? [],
        [authUser?.usersMarkets, setMarket],
    );

    return (
        <DropDownMenu id="marketselector" title={title} items={items}>
            <Badge
                role="button"
                aria-label={market?.name ?? ''}
                overlap="circular"
                sx={{ '> .MuiBadge-badge': { pointerEvents: 'none' } }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={
                    <SessionNavChip
                        title={market?.name}
                        label={
                            market ? (market.name.length > 12 ? market.name.substring(0, 9) + '...' : market.name) : ''
                        }
                    />
                }
            >
                <SessionNavAvatar>
                    <IconWorld size={20} />
                </SessionNavAvatar>
            </Badge>
        </DropDownMenu>
    );
};
